module.exports = __webpack_public_path__ + "img/Educational.1231fd6a.svg";